import { useState } from 'react'

import { ICON_COLOR, ICON_HEIGHT_24, IconNG } from '../../../../../Icon'

import { getHasListingBoardCardCoverImage } from './RentalPortalListingsBoardCardCover.utils'

import * as styles from './RentalPortalListingsBoardCardCover.module.css'

import RentalPortalIcon from '../../../../../../icons/rental-portal.svg'

function RentalPortalListingsBoardCardCover({ alt, coverThumbUrl }) {
  const [failedCoverUrl, setFailedCoverUrl] = useState(null)

  function handleError() {
    setFailedCoverUrl(coverThumbUrl)
  }

  return (
    <div className={styles.RentalPortalListingsBoardCardCover}>
      {getHasListingBoardCardCoverImage({ coverThumbUrl, failedCoverUrl }) ? (
        <img
          alt={alt}
          className={styles.image}
          draggable={false}
          src={coverThumbUrl}
          onError={handleError}
        />
      ) : (
        <IconNG
          Icon={RentalPortalIcon}
          color={ICON_COLOR.SecondaryTextColor50}
          size={ICON_HEIGHT_24}
        />
      )}
    </div>
  )
}

export default RentalPortalListingsBoardCardCover
